import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import SequenceVersionFileDetail from './SequenceVersionFileDetail';
import {
  getSequenceVersionFileManager,
  getSequenceVersion,
  getUserProfileWidget,
  getCurrentTimezone,
  getModelCategoryFlowSequences,
  getUserOrgModelCategoryType
} from '../../selectors/index';
import {
  describeSequenceVersionFileThunk,
  describeSequenceVersionThunk,
  saveSequenceVersionFileThunk,
  setSequenceVersionFileChangeThunk
} from '../../actions/sequenceVersion';

const mapStateToProps = state => {
  return {
    sequenceVersionFileManager: getSequenceVersionFileManager(state),
    sequenceVersionManager: getSequenceVersion(state),
    userProfileWidgets: getUserProfileWidget(state),
    currentTimezone: getCurrentTimezone(state),
    flowSequences: getModelCategoryFlowSequences(state),
    userModelCategories: getUserOrgModelCategoryType(state)

  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      describeSequenceVersionFile: (modelCategoryId, sequenceVersionId, sequenceVersionFileId, widgetCode) =>  describeSequenceVersionFileThunk(modelCategoryId, sequenceVersionId, sequenceVersionFileId, widgetCode),
      describeSequenceVersion: (modelCategoryId, sequenceVersionId, widgetCode) => describeSequenceVersionThunk(modelCategoryId, sequenceVersionId, widgetCode),
      saveSequenceVersionFile: (sequenceVersionFile, widgetCode) => saveSequenceVersionFileThunk(sequenceVersionFile, widgetCode),
      changeSequenceVersionFile: sequenceVersionFile => setSequenceVersionFileChangeThunk(sequenceVersionFile)

    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SequenceVersionFileDetail);
